import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// INTEGRATION APIS
// ================================

// 🔹 INTEGRATION LIST
export async function getIntegrationList(
  intigration_cre_by = "",
  intigration_type = "",
  intigration_status = "",
  page = "0"
) {
  try {
    const fd = new FormData();
    fd.append("intigration_cre_by", intigration_cre_by);
    fd.append("intigration_type", intigration_type);
    fd.append("intigration_status", intigration_status);
    fd.append("page", page);

    const response = await axios.post(`${apiBaseUrl}intigrationapis/getList`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getIntegrationList error:", error);
    return { status: false, type: "danger", success: "Failed to fetch integrations" };
  }
}

// 🔹 SAVE INTEGRATION (ADD / EDIT)
export async function saveIntegration(
  intigration_title,
  intigration_type,
  intigration_token1,
  intigration_token2,
  intigration_token3,
  intigration_token4,
  intigration_status,
  intigration_cre_by
) {
  try {
    const fd = new FormData();
    fd.append("intigration_id", "");
    fd.append("intigration_title", intigration_title);
    fd.append("intigration_type", intigration_type);
    fd.append("intigration_token1", intigration_token1);
    fd.append("intigration_token2", intigration_token2);
    fd.append("intigration_token3", intigration_token3);
    fd.append("intigration_token4", intigration_token4);
    fd.append("intigration_status", intigration_status);
    fd.append("intigration_cre_by", intigration_cre_by);

    const response = await axios.post(`${apiBaseUrl}intigrationapis/save_intigration`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveIntegration error:", error);
    return { status: false, type: "danger", success: "Integration save failed" };
  }
}

// 🔹 DELETE INTEGRATION
export async function deleteIntegration(intigration_title,intigration_type,intigration_cre_by) {
  try {
    const fd = new FormData();
    fd.append("intigration_title", intigration_title);
    fd.append("intigration_type", intigration_type);
    fd.append("intigration_cre_by", intigration_cre_by);

    const response = await axios.post(`${apiBaseUrl}intigrationapis/delete_intigration`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteIntegration error:", error);
    return { status: false, type: "danger", success: "Integration delete failed" };
  }
}
export async function getIntegration(intigration_title, intigration_type,intigration_cre_by) {
  try {
    const fd = new FormData();
    fd.append("intigration_title", intigration_title);
    fd.append("intigration_type", intigration_type);
    fd.append("intigration_cre_by", intigration_cre_by);

    const response = await axios.post(`${apiBaseUrl}intigrationapis/get_intigration`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getIntegration error:", error);
    return { status: false, type: "danger", success: "Integration delete failed" };
  }
}